// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_browserWarning__RzZIy {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #235AB5 0%, #AECBFA 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 999999;
  overflow-y: auto;
}

.styles_warningCard__Sbyqr {
  background: white;
  border-radius: 16px;
  padding: 32px 24px;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  animation: styles_slideUp__Z8RjF 0.3s ease-out;
}

@keyframes styles_slideUp__Z8RjF {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.styles_iconContainer__KJuPS {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.styles_warningIcon__meca9 {
  width: 56px;
  height: 56px;
  color: #EF554A;
}

.styles_title__k7WGj {
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 12px 0;
  color: #1f2937;
}

.styles_message__NQfUi {
  font-size: 16px;
  text-align: center;
  color: #6b7280;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.styles_buttonContainer__PxILZ {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.styles_primaryButton__3If22 {
  background: linear-gradient(135deg, #235AB5 0%, #AECBFA 100%);
  color: white;
  border: none;
  padding: 14px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.styles_primaryButton__3If22:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}
.styles_primaryButton__3If22:active {
  transform: translateY(0);
}

.styles_secondaryButton__Vii22 {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #e5e7eb;
  padding: 14px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.styles_secondaryButton__Vii22:hover {
  background: #e5e7eb;
}
.styles_secondaryButton__Vii22:active {
  background: #d1d5db;
}

.styles_instructions__ASxky {
  background: #f9fafb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.styles_instructionText__a1oSs {
  font-size: 14px;
  color: #374151;
  margin: 0 0 8px 0;
}

.styles_instructionList__NcuMN {
  margin: 0;
  padding-left: 20px;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.6;
}
.styles_instructionList__NcuMN li {
  margin-bottom: 6px;
}

.styles_skipButton__qqgC9 {
  background: transparent;
  color: #9ca3af;
  border: none;
  padding: 8px;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  display: block;
  margin: 0 auto;
  transition: color 0.2s;
}
.styles_skipButton__qqgC9:hover {
  color: #6b7280;
}

@media (max-width: 480px) {
  .styles_warningCard__Sbyqr {
    padding: 24px 20px;
  }
  .styles_title__k7WGj {
    font-size: 20px;
  }
  .styles_message__NQfUi {
    font-size: 15px;
  }
  .styles_primaryButton__3If22,
  .styles_secondaryButton__Vii22 {
    font-size: 15px;
    padding: 12px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/in-app-browser-detector/styles.module.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,qFAAA;EACA,8CAAA;AAAF;;AAGA;EACE;IACE,UAAA;IACA,2BAAA;EAAF;EAEA;IACE,UAAA;IACA,wBAAA;EAAF;AACF;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AADF;;AAIA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AADF;AAGE;EACE,2BAAA;EACA,+CAAA;AADJ;AAIE;EACE,wBAAA;AAFJ;;AAMA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAHF;AAKE;EACE,mBAAA;AAHJ;AAME;EACE,mBAAA;AAJJ;;AAQA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AALF;;AAQA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AALF;;AAQA;EACE,SAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AALF;AAOE;EACE,kBAAA;AALJ;;AASA;EACE,uBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;EACA,cAAA;EACA,cAAA;EACA,sBAAA;AANF;AAQE;EACE,cAAA;AANJ;;AAUA;EACE;IACE,kBAAA;EAPF;EAUA;IACE,eAAA;EARF;EAWA;IACE,eAAA;EATF;EAYA;;IAEE,eAAA;IACA,kBAAA;EAVF;AACF","sourcesContent":["@import \"mixins\";\n.browserWarning {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, #235AB5 0%, #AECBFA 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  z-index: 999999;\n  overflow-y: auto;\n}\n\n.warningCard {\n  background: white;\n  border-radius: 16px;\n  padding: 32px 24px;\n  max-width: 420px;\n  width: 100%;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  animation: slideUp 0.3s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.iconContainer {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.warningIcon {\n  width: 56px;\n  height: 56px;\n  color: #EF554A;\n}\n\n.title {\n  font-size: 24px;\n  font-weight: 700;\n  text-align: center;\n  margin: 0 0 12px 0;\n  color: #1f2937;\n}\n\n.message {\n  font-size: 16px;\n  text-align: center;\n  color: #6b7280;\n  margin: 0 0 24px 0;\n  line-height: 1.5;\n}\n\n.buttonContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.primaryButton {\n  background: linear-gradient(135deg, #235AB5 0%, #AECBFA 100%);\n  color: white;\n  border: none;\n  padding: 14px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  \n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  }\n  \n  &:active {\n    transform: translateY(0);\n  }\n}\n\n.secondaryButton {\n  background: #f3f4f6;\n  color: #374151;\n  border: 1px solid #e5e7eb;\n  padding: 14px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  \n  &:hover {\n    background: #e5e7eb;\n  }\n  \n  &:active {\n    background: #d1d5db;\n  }\n}\n\n.instructions {\n  background: #f9fafb;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.instructionText {\n  font-size: 14px;\n  color: #374151;\n  margin: 0 0 8px 0;\n}\n\n.instructionList {\n  margin: 0;\n  padding-left: 20px;\n  color: #6b7280;\n  font-size: 14px;\n  line-height: 1.6;\n  \n  li {\n    margin-bottom: 6px;\n  }\n}\n\n.skipButton {\n  background: transparent;\n  color: #9ca3af;\n  border: none;\n  padding: 8px;\n  font-size: 14px;\n  cursor: pointer;\n  text-decoration: underline;\n  display: block;\n  margin: 0 auto;\n  transition: color 0.2s;\n  \n  &:hover {\n    color: #6b7280;\n  }\n}\n\n@media (max-width: 480px) {\n  .warningCard {\n    padding: 24px 20px;\n  }\n  \n  .title {\n    font-size: 20px;\n  }\n  \n  .message {\n    font-size: 15px;\n  }\n  \n  .primaryButton,\n  .secondaryButton {\n    font-size: 15px;\n    padding: 12px 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"browserWarning": `styles_browserWarning__RzZIy`,
	"warningCard": `styles_warningCard__Sbyqr`,
	"slideUp": `styles_slideUp__Z8RjF`,
	"iconContainer": `styles_iconContainer__KJuPS`,
	"warningIcon": `styles_warningIcon__meca9`,
	"title": `styles_title__k7WGj`,
	"message": `styles_message__NQfUi`,
	"buttonContainer": `styles_buttonContainer__PxILZ`,
	"primaryButton": `styles_primaryButton__3If22`,
	"secondaryButton": `styles_secondaryButton__Vii22`,
	"instructions": `styles_instructions__ASxky`,
	"instructionText": `styles_instructionText__a1oSs`,
	"instructionList": `styles_instructionList__NcuMN`,
	"skipButton": `styles_skipButton__qqgC9`
};
export default ___CSS_LOADER_EXPORT___;
